import { Component } from '@angular/core';
import { EmpresaService } from 'src/app/services/empresa.service';
import { FacturaDatos, ProductoDatos } from 'src/app/models/empresa-facturas.interface';
import { AuthService } from 'src/app/services/auth.service';
import { ProductosFacturado } from 'src/app/models/empresa-productos-facturados.interface';
@Component({
  selector: 'app-productos-facurados-lst',
  templateUrl: './productos-facurados-lst.component.html',
  styleUrls: ['./productos-facurados-lst.component.scss']
})
export class ProductosFacuradosLstComponent {
  productos: ProductosFacturado[] = [];

  constructor(private authService: AuthService, private empresaService: EmpresaService) { this.load() }

  load(): void {

    if (this.authService.Session?.id) {

      if (this.authService.Session.fk_rol == 2) this.empresaService
        .empresaProductos(this.authService.Session?.id)
        .subscribe({ next: (resp) => { this.productos = resp.datos.productos_facturados; }, error: (err) => { console.error(err.error.message) } });
      if (this.authService.Session?.fk_rol == 1) this.empresaService
        .productosFacturados()
        .subscribe({ next: (resp) => { this.productos = resp.datos }, error: (err) => console.error(err) })
    }

  }

  trackByFactura(index: number, item: FacturaDatos) {
    return item.id;
  }
  trackByProducto(index: number, item: ProductoDatos) {
    return item.id;
  }
}
